import { parsePhoneNumber } from "awesome-phonenumber";

// Old validation logic by developion.
const validate = () => {
	try {
		// @ts-ignore
		if (document.querySelector("#position").value.length === 0) {
			document.querySelector(".position-error").classList.add("show");
			return false;
		} else {
			document.querySelector(".position-error").classList.remove("show");
		}
		// @ts-ignore
		if (document.querySelector("#firm").value.length === 0) {
			document.querySelector(".firm-error").classList.add("show");
			return false;
		} else {
			document.querySelector(".firm-error").classList.remove("show");
		}
		// @ts-ignore
		if (document.querySelector("#email").value.length === 0) {
			document.querySelector(".email-error").classList.add("show");
			return false;
		} else {
			document.querySelector(".email-error").classList.remove("show");
		}
		// @ts-ignore
		if (document.querySelector("#country").value.length === 0) {
			document.querySelector(".select-error").classList.add("show");
		} else {
			document.querySelector(".select-error").classList.remove("show");
		}
		// @ts-ignore
		if (!document.querySelector("#privacy").checked) {
			document.querySelector(".privacy-error").classList.add("show");
			return false;
		} else {
			document.querySelector(".privacy-error").classList.remove("show");
		}
	} catch {
		return false;
	}
};

const contactForm = document.querySelector(".contact-form");

if (contactForm) {
	const submit = contactForm.querySelector("#SubmitButton");
	const phoneInputs = <NodeListOf<HTMLInputElement>>contactForm.querySelectorAll("input[class='phone']");
	const checkboxes = <NodeListOf<HTMLInputElement>>contactForm.querySelectorAll(".product-checkbox");
	const checkboxError = document.querySelector(".checkbox-error");

	if (submit) {
		submit.addEventListener("click", (e) => {
			phoneInputs.forEach((phoneInput) => {
				if (phoneInput.value !== "") {
					const phoneNumber = parsePhoneNumber(phoneInput.value);
					const phoneError = phoneInput.parentElement.querySelector(".error");
					if (!phoneNumber.valid) {
						e.preventDefault();
						if (phoneError) {
							phoneError.classList.add("show");
						}
						return false;
					} else {
						if (phoneError) {
							phoneError.classList.remove("show");
						}
					}
				}
			});
			if (!Array.from(checkboxes).some((checkbox) => checkbox.checked)) {
				e.preventDefault();
				if (checkboxError) {
					checkboxError.classList.add("show");
				}
				return false;
			} else {
				if (checkboxError) {
					checkboxError.classList.remove("show");
				}
			}
			if (!validate()) {
				return false;
			}
		});
	}
}
